import { assign } from 'lodash';

const files = require.context('./icon', true, /\.js$/);
const generators = files.keys().map(key => files(key).default);

export default assign({}, ...generators);